export default __webpack_public_path__ + "static/media/documents.0ff5156e.svg";